module.exports = __webpack_public_path__ + "img/recommend.8bea4d43.png";